export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "долл. США",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Базовое предложение Workspace с интеллектуальными функциями для современных работников, которые используют SaaS- и веб-приложения, а также файлообменные сервисы.</p><p>Включает технологию единого входа (SSO) с поддержкой многофакторной аутентификации во всех приложениях; интеллектуальные функции Workspace с микроприложениями, персонализированными лентами и виртуальным помощником; сервис Citrix Content Collaboration Standard с файловым хранилищем неограниченного объема.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Комплексное решение Workspace, предназначенное для тех, кому необходимо полнофункциональное цифровое рабочее место с детальным контролем безопасности, но не требуются виртуальные приложения и десктопы.</p><p>Включает функционал Workspace Standard, а также дополнительные средства контроля безопасности для SaaS- и веб-приложений, систему унифицированного управления конечными устройствами и Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Комплексное решение для рабочих мест, включающее варианты для развертывания в гибридных средах для Citrix Virtual Apps and Desktops.</p><p>Включает функционал Workspace Premium, а также возможность управления облачными развертываниями для Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials поможет предприятиям малого и среднего бизнеса обеспечить безопасность данных благодаря упрощению и защите процесса входа в SaaS- и веб-приложения.</p><p>Для большей безопасности единый вход в SaaS- и веб-приложения выполняется с многофакторной аутентификацией, что помогает снизить вероятность взлома учетной записи на 99,9%.</p>"
            },
            terms: "* На пользователя, в месяц",
            btn1: "Посмотреть таблицу функций"
        },
        features: {
            disclaimer1: "* Ежемесячная средняя рекомендуемая производителем розничная цена в долларах США на пользователя для 500 пользователей с 3-летней подпиской. Фактические цены могут отличаться.<br /> Минимальное количество пользователей для лицензирования Citrix Workspace — 25.",
            disclaimer2: "** Workspace Analytics для развертываний Citrix Virtual Apps and Desktops на стороне потребителя не входит в состав сервиса Workspace Premium."
        },
        calculator: {
            edition: "Выберите версию",
            title: "Рассчитайте стоимость",
            users: "Выберите количество пользователей",
            estCost: "Ориентировочные ежемесячные расходы",
            btn1: "Поговорить с экспертом",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Минимальное количество пользователей для лицензирования — 25. Повторите попытку.",
            lowUserMsg: "У вас меньше 500 пользователей? Мы поможем удовлетворить потребности предприятия малого или среднего бизнеса.",
            volumeDiscount: "У вас больше 2500 пользователей? Воспользуйтесь тарифами со скидкой.",
            contract1: "Контракт на 1 год",
            contract3: "Контракт на 3 года",
            contract3savings: "Экономия 20%",
            term: "На пользователя, в месяц",
            disclaimer: "* Данный калькулятор показывает ориентировочную цену и предназначен исключительно для расчета бюджета. Фактические цены могут отличаться. Свяжитесь с командой или партнером Citrix, чтобы узнать о действующих скидках."
        },
        stats: {
            title: "Ваши преимущества",
            stat1: {
                title: "Повышение комфортности работы пользователей",
                desc: "<b>4 из 5</b> руководителей ИТ-отделов считают, что комфортность работы сотрудников играет важную роль в процессе цифровой трансформации."
            },
            stat2: {
                title: "Возможность выбора у сотрудников",
                desc: "<b>78%</b> бизнес-лидеров согласны с тем, что предоставление сотрудникам возможности выбирать, какие приложения и устройства использовать, повышает комфортность их работы."
            },
            stat3: {
                title: "Упрощение доступа",
                desc: "<b>47%</b> бизнес-лидеров заявляют, что больше всего на вовлеченность сотрудников влияет удобство доступа к информации, необходимой для выполнения работы."
            },
            btn1: "Поговорить с экспертом",
            disclaimer: "Источник: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}